import Big from 'big.js';
import * as lineitems from 'smg/customer-api/lineitems';
import * as html from 'smg/html';
import { DollarFormat } from 'smg/util';

document.querySelectorAll('.pricing-table').forEach(async $pricingTable => {
    const lineItem = $pricingTable.getAttribute('data-line-item');
    const type = $pricingTable.getAttribute('data-type');
    const minQty = parseInt($pricingTable.getAttribute('data-min-qty') || '0', 10);
    const allowedSizes = new Set(($pricingTable.getAttribute('data-sizes') ?? '').split(';').filter(Boolean));

    if (!lineItem || !type) {
        return;
    }

    const $thead = $pricingTable.querySelector('thead') as HTMLTableSectionElement;
    const $tbody = $pricingTable.querySelector('tbody') as HTMLTableSectionElement;

    $thead.innerHTML = '';
    $tbody.innerHTML = '';

    const sizes = await lineitems.GetSizes(lineItem, type);

    const qtys = new Set<number>();
    for (const size of sizes) {
        if (allowedSizes.size && !allowedSizes.has(size.name)) {
            continue;
        }

        for (const price of size.prices) {
            if (minQty && price.quantity < minQty) {
                continue;
            }

            qtys.add(price.quantity);
        }
    }

    const qtysSorted = Array.from(qtys).sort((a, b) => a - b);

    const pricesBySize = new Map<string, Map<number, Big>>();
    for (const size of sizes) {
        if (allowedSizes.size && !allowedSizes.has(size.name)) {
            continue;
        }

        const prices = new Map<number, Big>();
        for (const price of size.prices) {
            prices.set(price.quantity, price.price);
        }
        pricesBySize.set(size.name, prices);
    }

    const $tr = html.FromString('<tr><th>Size</th></tr>');
    $thead.appendChild($tr);

    for (const qty of qtys) {
        $tr.appendChild(html.FromString(`<th>${Intl.NumberFormat().format(qty)}</th>`));
    }

    for (const [size, prices] of pricesBySize) {
        const $tr = html.FromString(`<tr><th scope="row">${html.Escape(size)}</th></tr>`);
        $tbody.appendChild($tr);

        for (const qty of qtysSorted) {
            const price = prices.get(qty);
            $tr.appendChild(html.FromString(`<td>${price ? DollarFormat(price) : ''}</td>`));
        }
    }
});